import { Component, Input, OnInit } from '@angular/core';
import { ModalPromptModel } from '@shared/interfaces/modal-prompt-model.interface';
import { ModalPromptService } from '@core/services/modal-prompt.service';

@Component({
  selector: 'app-modal-prompt',
  imports: [],
  templateUrl: './modal-prompt.component.html',
  styleUrl: './modal-prompt.component.scss',
})
export class ModalPromptComponent implements OnInit {
  @Input() structure?: ModalPromptModel | null;
  @Input() open = false;

  constructor(private readonly _modalPromptService: ModalPromptService) {}

  ngOnInit() {
    this._modalPromptService.$modalStructure.subscribe((value) => {
      this.structure = value;
    });

    this._modalPromptService.$openModal.subscribe((value) => {
      this.open = value;
    });
  }

  onPrimaryClick(event: Event): void {
    this._modalPromptService.emitPrimaryButtonClick(event);
  }

  onWarningClick(event: Event): void {
    this._modalPromptService.emitWarningButtonClick(event);
  }
}
